import React, { useEffect, useState } from 'react';
import { getStorageUsage } from '../../../services/attachmentService';
import { formatFileSize } from '../../SprintDetail/shared/AttachmentsModal/utils/formatters';
import { useAuth } from '../../AuthProvider';
import './AccountStorageSection.css';

/**
 * Workspace file storage meter (mission attachments + uploaded doc videos).
 * One cheap Dynamo read via GET /attachments/storage — not a full recount.
 */
export function AccountStorageSection() {
  const { workspaceId } = useAuth();
  const [storageUsed, setStorageUsed] = useState(0);
  const [storageLimit, setStorageLimit] = useState(100 * 1024 * 1024 * 1024);
  const [status, setStatus] = useState('loading'); // loading | ready | error

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');
    getStorageUsage()
      .then((result) => {
        if (cancelled) return;
        setStorageUsed(result.storageUsed || 0);
        setStorageLimit(result.storageLimit || 100 * 1024 * 1024 * 1024);
        setStatus('ready');
      })
      .catch((err) => {
        console.warn('Failed to load storage usage:', err?.message || err);
        if (!cancelled) setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  const percent =
    storageLimit > 0 ? Math.min(100, (storageUsed / storageLimit) * 100) : 0;
  const level = percent >= 95 ? 'critical' : percent >= 80 ? 'warning' : 'ok';

  return (
    <div className="account-storage">
      <div className="account-storage__header">
        <span className="account-storage__label">Used</span>
        <span className="account-storage__value">
          {status === 'loading' && 'Loading…'}
          {status === 'error' && 'Unavailable'}
          {status === 'ready' &&
            `${formatFileSize(storageUsed)} / ${formatFileSize(storageLimit)}`}
        </span>
      </div>
      <div
        className="account-storage__bar"
        data-level={status === 'ready' ? level : undefined}
      >
        <div
          className="account-storage__fill"
          style={{ width: status === 'ready' ? `${percent}%` : '0%' }}
        />
      </div>
      <p className="account-storage__hint">
        Shared 100GB pool in this brain for mission attachments (paperclip
        files) and images/videos uploaded into docs. YouTube/Vimeo/Loom embeds
        and custom icons don’t count.
      </p>
    </div>
  );
}

export default AccountStorageSection;
